import { queryOptions } from '@tanstack/react-query';
import customerPortalApi from '..';
import type { RequestOpts } from '../api-types';
import queryClient from '../queryClient';

const method = customerPortalApi.getCalculationInterestsheet;

function getInterestSheetQuery(opts: RequestOpts = {}) {
  const queryKey = ['getInterestSheet'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return method({
        ...opts,
        signal,
      });
    },
  });
}

export function fetchInterestSheet(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getInterestSheetQuery(opts));
}
